// @ts-nocheck

import { ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { Route, RouteProps } from 'react-router-dom'
import { ReduxState } from '../redux/rootReducer'
import { useCookies } from 'react-cookie'
import { motion } from 'framer-motion'

export type PrivateRouteProps = {
  component: ReactNode
} & RouteProps

export const PrivateRoute = ({ component, ...rest }: PrivateRouteProps) => {
  const [getCookie, , removeCookie] = useCookies(['applaus-auth-customer'])

  const { UserReducer } = useSelector((state: ReduxState) => state)

  const hasCookie = Boolean(getCookie['applaus-auth-customer'])
  const hasEmail = UserReducer.email !== ''
  const hasAccessToken = Boolean(UserReducer.accessToken)
  // Only wait while auth bootstrap is in progress — not after a failed hydrate.
  const isAuthLoading = UserReducer.loading === true
  const hydrateFailed =
    hasCookie && !hasAccessToken && !isAuthLoading && !hasEmail
  const shouldRedirect =
    (!isAuthLoading && !hasCookie && !hasEmail) || hydrateFailed

  if (isAuthLoading) {
    return null
  }

  if (shouldRedirect) {
    if (hydrateFailed) {
      removeCookie('applaus-auth-customer', {
        path: '/',
        domain: process.env.REACT_APP_DOMAIN
      })
    }
    window.location.href = `${
      process.env.REACT_APP_AUTH_URL
    }/url?name=${encodeURIComponent(window.location.href)}`
    return null
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}>
      <Route {...rest} component={component} />
    </motion.div>
  )
}
